import styled from 'styled-components';

export const Wrapper = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	opacity: 0;
	visibility: hidden;
	z-index: 100111;
	transition: 0.2s;
	/* .business-card p {
		font-family: 'KBFG Text' !important;
	} */

	.overlay {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.4);
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
		visibility: hidden;
		z-index: -1;
		transition: 0.2s;
	}
	.container {
		position: absolute;
		left: 50%;
		bottom: 0;
		transform: translate(-50%, 100%);
		width: 100%;
		z-index: 100;
		border-radius: 22px;
		background-color: transparent;
		transition: 0.2s;

		/* overflow: ${(props) => (props.auto ? props.auto : `auto`)}; */
	}
	.title {
		display: flex;
		gap: 8px;
		font-size: 15px;
		font-weight: 700;
		line-height: normal;
	}
	.close-btn {
		position: absolute;
		top: -14px;
		right: 0px;
		transform: translateY(-100%);
		cursor: pointer;
		padding: 6px;
	}
	.toggle {
		padding: 30px;
		position: relative;
		z-index: 10;
		transform: translateY(20px);
		transition: all 0.3s;
		border-radius: 22px;
		border: 1px solid #eee;
		background: #fff;
		height: 162px;
		&.open {
			transform: translateY(20px);
			transition: all 0.3s;
			height: 290px;
		}
		.content {
			padding-bottom: 20px;
			.flex {
				display: flex;
				justify-content: center;
				gap: 76px;
				text-align: center;
				p {
					color: #666;
					margin-top: 10px;
					font-size: 13px;
					font-weight: 400;
					line-height: normal;
					text-decoration: none;
					font-family: 'Pretendard' !important;
				}
			}
			.line {
				border-top: 1.5px solid #fbfbfb;
				margin: 20px -30px 0 -30px;
				position: relative;
				top: -5px;
			}
		}

		.toggle-btn {
			position: absolute;
			top: -20px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 101;
		}

		.flex {
			display: flex;
			align-items: center;
			justify-content: space-between;
			.left {
				display: flex;
				align-items: end;
				gap: 10px;
				h1 {
					font-size: 24px;
					font-weight: 700;
					letter-spacing: 0.48px;
				}
				span {
					font-size: 13px;
					font-weight: 500;
				}
			}
			.right {
				p {
					display: flex;
					gap: 8px;
					font-size: 13px;
					font-weight: 400;
				}
			}
		}
		.cont {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			padding: 30px;
			overflow: hidden;
			z-index: 100;
			border-radius: 22px;
			background-color: #fff;
			&.open {
			}
		}
		.info {
			color: #999;
			font-size: 14px;
			font-weight: 600;
			letter-spacing: 0.56px;
			text-align: left;
			img {
				vertical-align: middle;
				margin-right: 8px;
			}
		}
		.phone {
			margin-top: 14px;
		}
		.mail {
			margin-top: 11px;
		}
	}
	.user-box {
		height: 100%;
		background-color: #000;
		position: relative;
		color: #fff;
		padding: 20px 30px;
		.close {
			position: relative;
			z-index: 10;
		}
		.bg {
			background-image: url(/images/bg06.png);
			width: 100%;
			height: calc(100% - 312px);
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			position: absolute;
			top: 0px;
			right: 0;
		}
		.text-box {
			width: 100%;
			margin-top: 50px;
			text-align: right;
			position: relative;
			z-index: 1;
			h2 {
				font-size: 24px;
				font-weight: 700;
				letter-spacing: 0.48px;
				margin-bottom: 20px;
			}
			p {
				font-size: 14px;
				font-weight: 300;
				line-height: 160%;
				letter-spacing: 0.28px;
				opacity: 0.6;
			}
		}
	}
	.user {
		width: 100%;
		height: calc(100% - 312px);
		/* padding-bottom: 100%; */
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		/* margin-top: 78px; */
		position: absolute;
		top: 58px;
		z-index: 100;
	}
	.footer {
		background-color: #000;
		width: 100%;
		height: 100%;
		position: relative;
		top: 100%;
		height: 97px;
		.logo-box {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 97px;
			position: relative;
			top: 8px;
			img {
				width: 140px;
			}
		}
	}

	// 홈에서
	${(props) =>
		props.home
			? `
      @media (max-width: 500px) {
      .container {
        max-width: 100vw;
      }
      
    }
    @media (max-width: 460px) {
      .container {
        // max-width: initial;
      }
      
    }

  
  `
			: ``}

	${(props) =>
		props.active
			? `
      opacity: 1;
      visibility: visible;
      transition: 0.2s;
      z-index: 100011;
      .overlay {
        opacity: 1;
        visibility: visible;
        z-index: 50;
      }
      .container {
        transform: translate(-50%, 0%);
      }
    `
			: ``}
`;
